import React from "react";
import axios from "axios";
import { isFinesSortType } from "../HostSystemItemSortControl";
import { HostSystemItemSortType } from "@tlc/ls2pac/dto/HostSystemItemSortType";
import { LoaderFunctionArgs } from "react-router-dom";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { HostSystemDiag } from "../../resource/ItemAvailability";

export interface GetFeesReturn {
  fees: HostSystemItemView[];
  hostSystemDiag: HostSystemDiag;
  totalFees: number;
}

export const getFinesSortable = async (
  page: number,
  count: number,
  sortType: HostSystemItemSortType,
  refreshToken: number,
) => {
  const response = await axios.get<GetFeesReturn>(
    `/fees/${page * count}/${count}/${sortType}?_=${refreshToken}`,
  );

  return response.data;
};

export const finesLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const sortParam = url.searchParams.get("sort");
  const sort =
    sortParam && isFinesSortType(sortParam)
      ? sortParam
      : HostSystemItemSortType.OutDate;

  const page = url.searchParams.has("page")
    ? parseInt(url.searchParams.get("page")!)
    : 0;

  const pageSize = url.searchParams.has("size")
    ? parseInt(url.searchParams.get("size")!)
    : 10;

  const refreshToken = Date.now();

  const dataPromise = getFinesSortable(page, pageSize, sort, refreshToken)
    .then((feesRes) => ({
      sort,
      page,
      pageSize,
      fees: feesRes.fees,
      feesTotalCount: feesRes.totalFees,
      refreshToken,
    }))
    .catch((error) => {
      console.error("Error fetching fines", error);
      if (axios.isAxiosError(error) && error.response?.status === 403) {
        throw new Response("Forbidden", { status: 403 });
      }
      throw error;
    });
  return { data: dataPromise, pageSize: pageSize }; // need synchronous pageSize for skeletons array in React.Suspense fallback
};
